module.exports = __webpack_public_path__ + "static/media/signature.00b97900.png";